<span *ngIf="hasBrand()" class="me-1">
  <img *ngIf="hasLogo()" class="small-logo" [src]="carTypeService.getCarBrandLogoUrl(carBrand.BrandLogo,'20x20')" [alt]="carBrand.BrandName" />
  <span *ngIf="!hasLogo()" class="no-logo"></span>
</span>
<span>{{getName()}}</span>
